import './Card.scss'

import { PropsWithChildren } from "react";

export enum CardMode {
    DEFAULT = 'default',
    SQUARE = 'square'
}

export enum CardBorderColor {
    LIGHTEST_BLUE = 'lightest-blue',
    LIGHT_GREEN = 'light-green',
    LIGHT_YELLOW = 'light-yellow'
}

export interface CardProps extends PropsWithChildren<unknown>{
    hideBorderOnMobile?: boolean;
    mode?: CardMode
    borderLeftColor?: CardBorderColor
    class?: string
}

const Card = (props: CardProps) => {

    const cardClass = 'card-box'
    const mobileClass = props.hideBorderOnMobile ? `${cardClass}--mobile-no-border` : '';
    const modeClass = `${cardClass}--${props.mode || 'default'}`
    const borderClass = props.borderLeftColor ? `${cardClass}--border ${cardClass}--border-${props.borderLeftColor}` : ''

    return (
        <div className={`${cardClass} ${modeClass} ${mobileClass} ${props.class}`}>
            {!!borderClass && <div className={borderClass} />}
            {props.children}
        </div>
    )
}

export default Card
